"use strict";
/*
 * Created on 25. 3. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * Converter of {@link SelloutReleaseItemUpdate}.
 * @author Radek Beran
 */


var SelloutReleaseItemUpdateConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SelloutReleaseItemUpdateConverter, _DataObjectConverter_);

  function SelloutReleaseItemUpdateConverter() {
    _classCallCheck(this, SelloutReleaseItemUpdateConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseItemUpdateConverter).apply(this, arguments));
  }

  return SelloutReleaseItemUpdateConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SelloutReleaseItemUpdateConverter = SelloutReleaseItemUpdateConverter;